<template>

<div v-show="showLocationDetailsModal">
<div v-if="DataLoading">
    <div class="modal-overlay" >
          <center><div class="loader" style="margin-top: 160px;"></div></center>
        </div>
            </div>
            <div v-else>
    
       <div class="modal-overlay" >
        <Modal class="custom-modal custom-modal-width2" v-show="showLocationDetailsModal">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-header-text2">
                        Location name - {{LocationDetails.name}} <br>
                        <div class="modal-text3">To change any of these details, kindly reach out</div>
                        <div class="modal-text3">to support</div>
                 </div>
                
                    <button type="button" class="close" @click="CloseMoreDetailsModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
    
              <div class="modal-body modal-body9 modal-text" style="max-height: 510px; min-height: 480px;">
               <div class="location-detail-card">
                    <table class="table1">
                <tr>
                    <th>Name</th>
                    <th>Address</th>
                    <th>State</th>
                    <th>LGA</th>
                </tr>
                <tr>
                    <td>{{LocationDetails.name}}</td>
                    <td>{{LocationDetails.address}}</td>
                    <td>{{LocationDetails.state}}</td>
                    <td>{{LocationDetails.lga}}</td>
                </tr>
                    </table>

        <div class="divider" style="background-color: #656060; opacity: 20%; margin-top: 10px; margin-bottom: 10px;"></div>
        <!-- <div class="modal-text3" style="font-weight: normal; color: #000; font-size: 14px;">If you enable this feature, your cashier can receive tips</div>
        <div class="modal-text3" style="font-weight: normal; color: #000; font-size: 14px;">from customers</div>


        <div style="display: flex; justify-content: space-between; margin-top: 30px;">
            <div>
                <div class="modal-text3" style="font-weight: normal; color: #000; font-size: 14px;">
                    <img src="@/components/img/Sales_Assests/cashicon.svg" alt="Icon" class="icon-right">
                    Tip Cashier</div> 
            </div>
           
              <label for="TipCashier"></label>
              <div class="custom-control custom-switch">
              <input
                  type="checkbox"
                  class="custom-control-input"
                  id="TipCashier"
                  :checked="LocationDetails.isTippingActive"
                  @change="toggleTippingActive"
              />
              <label class="custom-control-label" style="border-color: #000;" for="TipCashier">
                  {{ LocationDetails.isTippingActive ? '' : '' }}
              </label>
          </div>

        </div> -->

               </div>

               <div style="margin-top: 20px; font-weight: bold; font-size: 12px; color: #000;">
                        All Cashiers</div>
            <div v-if="cashierList.length == 0">
              <center><div class="modal-text3 mt-5">No cashier available</div></center>
            </div>
            <div v-else>
            <div class="location-modal mt-3" style="max-height: 250px; min-height: 170px;">
            <div v-for="(cashier, index) in cashierList" :key="index" class="location-card7">
            <div class="list-number">{{ index + 1 }}</div>
            <div class="location-details">
              <div class="detail">
                First Name: <strong class="mr-3"> {{ cashier.firstname.length > 7 ? cashier.firstname.substring(0, 7) + '...' : cashier.firstname }}</strong>
                Last Name: <strong> {{ cashier.lastname.length > 3 ? cashier.lastname.substring(0, 3) + '...' : cashier.lastname}}</strong>
              </div>
            </div>
            <div class="edit-text" @click="editCashier(index)"><strong class="edit-text">View</strong></div>
          </div>
        </div>
      </div>

        <!-- <div class="button-container" style="margin-top: 20px; width: auto;" @click="openAddcashierModal">
        <button class="onboard-button2" style="width: 100%; height: 40px;" >
        Add Cashier</button>
        </div> -->
              </div>
    
            </div>
          </div>
        </Modal>
      </div>
      </div>
      
    </div>

    
    <div class="modal-overlay" v-show="showAddCashierModal">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    <Modal class="custom-modal custom-modal-width2" v-show="showAddCashierModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="loader-container" v-if="isUpdatingCashier">
          <div class="center-content3">
            <div style="margin-bottom: 250px; font-size: 12px; color: #000;">
        <center><div class="loader2" style="margin-bottom: 15px;"></div></center>
        <p>Adding Cashier...</p>
      </div>
    </div>
      </div>
      <div v-else>
        <div class="modal-header">
            <div @click="openLocationModal" style="color: #000; font-size: 12px; margin-left: 10px; margin-top: 15px; cursor: pointer;">
                <i class="fas fa-arrow-left"></i><span> Back</span> 
            </div>
            <button type="button" class="close" @click="CloseMoreDetailsModal">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-header">
               
        <div v-if="DetailsModal" class="modal-header-text2">
            Add Cashier to {{LocationDetails.name}}, {{LocationDetails.lga}}
            </div>
            </div>

            <form @submit.prevent="addCashier">
            <div class="modal-body modal-body9 modal-text" style="max-height: 480px;">

            <!-- Cashier First Name -->
            <div class="form-group">
              <label for="CashierFirstName">First Name</label>
              <input type="text" id="CashierFirstName" required class="form-control" v-model="CashierFirstName" placeholder="Enter First Name" style="font-size: 12px; background-color: #F8F9FC">
            </div>

           <!-- Cashier Last Name -->
           <div class="form-group">
              <label for="CashierLastName">Last Name</label>
              <input type="text" id="CashierLastName" required class="form-control" v-model="CashierLastName" placeholder="Enter Last Name" style="font-size: 12px; background-color: #F8F9FC">
            </div>

           <!-- Cashier Phone Number -->
           <div class="form-group">
              <label for="CashierPhoneNumber">Phone Number</label>
              <input type="text" id="CashierPhoneNumber" maxlength="11" class="form-control" required v-model="CashierPhoneNumber" placeholder="Enter cashier phone number" style="font-size: 12px; background-color: #F8F9FC">
            </div>

            <!-- Cashier Email -->
            <div class="form-group">
              <label for="cashierEmail">Email Address</label>
              <input type="email" id="cashierEmail" class="form-control" required v-model="cashierEmail" placeholder="Enter cashier email address" style="font-size: 12px; background-color: #F8F9FC;">
            </div>

            <div class="button-container" style="margin-top: 70px; width: auto;" >
        <button class="onboard-button2" type="submit" style="width: 100%; height: 40px;"> Add</button>
        </div>
          </div>
        </form>

          

        </div>
        </div>
      </div>
    </Modal>
  </div>

  <div class="modal-overlay" v-show="showEditCashierModal">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    <Modal class="custom-modal custom-modal-width2" v-show="showEditCashierModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="loader-container" v-if="isUpdatingCashier">
          <div class="center-content3">
            <div style="margin-bottom: 250px; font-size: 12px; color: #000;">
        <center><div class="loader2" style="margin-bottom: 15px;"></div></center>
        <p>Updating Cashier Details...</p>
      </div>
    </div>
      </div>
      <div v-else>
        <div class="modal-header">
            <div @click="openLocationModal" style="color: #000; font-size: 12px; margin-left: 10px; margin-top: 15px; cursor: pointer;">
                <i class="fas fa-arrow-left"></i><span> Back</span> 
            </div>
            <button type="button" class="close" @click="CloseMoreDetailsModal">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-header">
               
                    <div class="modal-header-text2">
                        <center>Cashier Details</center>
                        </div>
                        </div>


            <div class="modal-body modal-body9 modal-text" style="max-height: 480px;">

            <!-- Cashier First Name -->
            <div class="form-group">
              <label for="CashierFirstName">First Name</label>
              <input type="text" id="CashierFirstName" disabled class="form-control" v-model="CashierFirstName" placeholder="Enter First Name" style="font-size: 12px; background-color: #F8F9FC">
            </div>

           <!-- Cashier Last Name -->
           <div class="form-group">
              <label for="CashierLastName">Last Name</label>
              <input type="text" id="CashierLastName" disabled class="form-control" v-model="CashierLastName" placeholder="Enter Last Name" style="font-size: 12px; background-color: #F8F9FC">
            </div>

           <!-- Cashier Phone Number -->
           <div class="form-group">
              <label for="CashierPhoneNumber">Phone Number</label>
              <input type="text" id="CashierPhoneNumber" disabled maxlength="11" class="form-control" v-model="CashierPhoneNumber" placeholder="Enter cashier phone number" style="font-size: 12px; background-color: #F8F9FC">
            </div>

            <!-- Cashier Email -->
            <div class="form-group">
              <label for="cashierEmail">Email Address</label>
              <input type="email" id="cashierEmail" disabled class="form-control" v-model="cashierEmail" placeholder="Enter cashier email address" style="font-size: 12px; background-color: #F8F9FC; margin-bottom: 80px;">
            </div><br>
            
            <!-- <div class="button-container" style="margin-top: 90px; width: auto;" >
              <div class="modal-footer">
                <div class="previous-button" >Delete</div>
        <button class="onboard-button2" style="width: 100%; height: 40px;" @click="EditCashier(cashierID)">
        Save Changes</button>
        </div>
        </div> -->

        <!-- <div class="modal-footer" style="padding: 0;">
            <div class="previous-button"  style="color: red;">Delete</div>
            <div class="onboardNext-button" style="width: 305px; margin: 0;" @click="EditCashier(cashierID)">Save Changes</div>
          </div> -->
          </div>

          

        </div>
      </div>
      </div>
    </Modal>
  </div>
    
    </template>
    
    <script>
    //  import axios from 'axios';
    import axios from 'axios';
import debounce from 'lodash/debounce';
    
      
    export default {
      props:  ['LocationData', 'showLocationDetailsModal', 'fetchLocationData'],
    
      data() {
      return {
        selectedTab: 'Business Details',
        DataLoading: true,
        isUpdatingCashier: false,
        LocationDetails: null,
        cashierList: [],
        cashierID: '',
        CashierFirstName: '',
        CashierLastName: '',
        CashierPhoneNumber: '',
        cashierEmail: '',
        showAddCashierModal: false,
        showEditCashierModal: false,
        DetailsModal: false,
      }
    },

   watch: {

  fetchLocationData: {
  handler: debounce(function(newValue) {
    if (this.fetchLocationData) {
      this.fetchLocationDetails();
      console.log(newValue)
    }
  }, 1000),
  immediate: true,
},
    },
    
    methods: {

    editCashier(index) {
    const cashier = this.cashierList[index];
    this.cashierID = cashier.id;
    this.CashierFirstName = cashier.firstname;
    this.CashierLastName = cashier.lastname;
    this.CashierPhoneNumber = cashier.phoneNumber;
    this.cashierEmail = cashier.email;
    this.openEditcashierModal();
  },

  async EditCashier(cashierID){
    this.isUpdatingCashier = true;
        try {

          const payload = {
            firstname: this.CashierFirstName,
            lastname: this.CashierLastName,
            phoneNumber: this.CashierPhoneNumber,
            email: this.cashierEmail
          }
          const response = await axios.put(`${this.$config.ADDCASHIER_ENDPOINT}/${cashierID}/update`, payload)
          
          if(response.status == 200){
            this.$toast.open({
          message: 'Cashier Has been Updated Successfully',
          type: 'success',
          duration: 3000,
          });
          this.fetchLocationDetails();
          this.openLocationModal();
          this.isUpdatingCashier = false;
          // Clear the form fields
          this.cashierID = '';
          this.CashierFirstName = '';
          this.CashierLastName = '';
          this.CashierPhoneNumber = '';
          this.cashierEmail = '';
          }

        }catch(error){
          this.isUpdatingCashier = false;
          console.log('Unable to Update cashier Details',error);
          this.$toast.open({
          message: 'Unable to fetch cashier Details',
          type: 'warning',
          duration: 3000,
          });
        }
          

      },

     async fetchLocationDetails(){
      console.log('gotten location Details',this.LocationData);
        try {
          const response = await axios.get(`${this.$config.GETLOCATIONSDETAILS_ENDPOINT}/${this.LocationData.id}`)
          
          if(response.status == 200){
            this.LocationDetails = response.data.data;
            this.cashierList = response.data.data.cashiers;
            this.DataLoading = false;
          }

        }catch(error){

          console.log('Unable to fetch location Details',error);
          this.$toast.open({
          message: 'Unable to fetch location Details',
          type: 'warning',
          duration: 3000,
          });
          this.DataLoading = false;
          this.CloseMoreDetailsModal();
        }
          

      },


      async addCashier() {
          this.isUpdatingCashier = true;
          try {

          const payload = {
            firstname: this.CashierFirstName,
            lastname: this.CashierLastName,
            phoneNumber: this.CashierPhoneNumber,
            email: this.cashierEmail
          }
          const response = await axios.post(`${this.$config.ADDCASHIER_ENDPOINT}/${this.LocationData.id}/add`, payload)
          
          if(response.status == 200){
            this.$toast.open({
          message: 'Cashier has been Added Successfully',
          type: 'success',
          duration: 3000,
          });
          this.fetchLocationDetails();
          this.$emit('reload-business');
          this.openLocationModal();
          this.isUpdatingCashier = false;
          // Clear the form fields
          this.cashierID = '';
          this.CashierFirstName = '';
          this.CashierLastName = '';
          this.CashierPhoneNumber = '';
          this.cashierEmail = '';
          }

        }catch(error){
          this.isUpdatingCashier = false;
          console.log('Unable to Add cashier to Location',error);
          this.$toast.open({
          message: 'Unable to Add cashier to Location',
          type: 'warning',
          duration: 3000,
          });
        }
  },

        openLocationModal(){
            this.showAddCashierModal = false;
            this.showEditCashierModal = false;
            this.DetailsModal = false;
            this.$emit('open-modal2');
            
        },

        openAddcashierModal(){
            this.$emit('close-modal2');
            this.showAddCashierModal = true;
            this.DetailsModal = true;
        },

        openEditcashierModal(){
            this.$emit('close-modal2');
            this.showEditCashierModal = true;
        },

        CloseMoreDetailsModal(){
            this.$emit('close-modal2');
            this.$emit('reset-location-detail');
            this.DataLoading = true;
            this.cashierList = [];
            this.LocationDetails = null;
            this.showAddCashierModal = false;
            this.showEditCashierModal = false;
            this.DetailsModal = false;
            // Clear the form fields
            this.cashierID = '';
            this.CashierFirstName = '';
            this.CashierLastName = '';
            this.CashierPhoneNumber = '';
            this.cashierEmail = '';
            

    
        },
    
        selectTab(tab) {
        this.selectedTab = tab;
      
      },
    }
    
    }
    
    </script>
    
    <style scoped>

.location-card7 {
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: #F1F3F9;
  height: 40px;
}
     .table1 {
    width: 100%;
    border-collapse: collapse;

    th, td {
    padding: 2px;
    text-align: left;
  }

  td{
    font-weight: bold;
    color: #212020;
    font-size: 13px;
  }
  
  th {
    width: auto;
    font-size: 12px;
    color: #b0a8a8;
    font-weight: normal;
  }
  }

    .location-detail-card{
        height: 100px;
        width: 415px;
        border: 1px solid #000;
        border-radius: 5px;
        background-color: #FFF9ED;
        padding: 15px;
    }
    
    .modal-body-detail {
      max-height: 350px;
      overflow-y: auto;
    }
    
    .tab-buttons2 {
      display: flex;
      margin-bottom: 15px;
    }
    
    .tab-buttons2 button {
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 14px;
      margin-right: 10px;
      padding: 10px;
      color: #b0a8a8;
      width: 140px;
      height: 30px;
      font-size: 13px;
    }
    
    .tab-buttons2 button.activeTab {
      border-bottom: 2px solid #6F48FF; /* Active tab indicator color */
      color: #000; /* Active tab text color */
      font-weight: bold;
    }
    
    </style>